<template>
  <div class="family-group-manage">
    <div>
      <div>
        <label for="nameInput" class="form-label">
          Group name
        </label>
        <InPlaceTextEdit id="nameInput" v-model="editFamilyGroup.name" required :disabled="!canEditRef"/>
      </div>
    </div>
    <div class="owner-area">
      <label class="form-label">
        Group owner
        <button type="button" v-if="canEditRef" class="btn btn-inline btn-link inline-action" @click="notImplemented">
          change
        </button>
      </label>
      <UserItem :user-id="familyGroupRef?.ownerId" no-hover/>
    </div>
    <div>
      <label class="form-label">Created</label>
      <div class="input-value">
        {{ DateTimeUtil.toUserActionDate(familyGroupRef?.createdDate) }}
        <span class="date-relative">({{ DateTimeUtil.toRelativePastDate(familyGroupRef?.createdDate) }})</span>
      </div>
    </div>
    <div class="actions">
      <button type="button" id="confirmDelete" v-if="canEditRef" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#deleteModal">
        <Trash2Icon></Trash2Icon> Delete group
      </button>
    </div>
    <Modal id="deleteModal" ref="deleteModalRef" ok-style="danger" @ok="deleteGroup">
      <template #title>Delete group</template>
      <div>
        <p>Are you sure you want to delete this group?</p>
      </div>
      <template #okIcon><Trash2Icon/></template>
      <template #okText>Delete</template>
      <template #busyText>Deleting...</template>
    </Modal>
  </div>
</template>

<style lang="scss" scoped>
.family-group-manage {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.owner-area {
  .user-item {
    margin-left: 0.25rem;
  }
}

.date-relative {
  font-size: 0.875rem;
  color: #888;
}
</style>

<script lang="ts" setup>
import { computed, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useFamilyGroupStore } from '@/gp/FamilyGroupStore'
import { LoadMode } from '@/util/AsyncData'
import { FamilyGroup, ItemPermissions } from '@/gp/GroupAdminModel'
import { useInstantSave } from '@/util/InstantSave'
import { DateTimeUtil } from '@/util/LuxonUtil'
import { Trash2Icon } from '@zhuowenli/vue-feather-icons'
import { notImplemented } from '@/util/AppUtil'
import InPlaceTextEdit from '@/util/InPlaceTextEdit.vue'
import UserItem from '@/manage/users/UserItem.vue'
import Modal from '@/util/Modal.vue'

const props = defineProps<{
  familyGroupId: string
}>()

const deleteModalRef = ref<InstanceType<typeof Modal>>()

const familyGroupStore = useFamilyGroupStore()
const router = useRouter()

const familyGroupRef = computed(() => familyGroupStore.getAsyncGroup(props.familyGroupId, LoadMode.EnsureLoaded)?.data)
const permissionsRef = computed(() => familyGroupStore.getAsyncPermissions(props.familyGroupId, LoadMode.EnsureLoaded)?.data)
const canEditRef = computed(() => (permissionsRef.value ?? 0) & ItemPermissions.Modify)

async function deleteGroup() {
  await familyGroupStore.deleteAsync(props.familyGroupId!)
  deleteModalRef.value?.close()
  router.push("/groups")
}

const editFamilyGroup = reactive(new FamilyGroup())
const editProperties = ['name'] as (keyof FamilyGroup)[]
useInstantSave(familyGroupRef, editFamilyGroup, editProperties,
  changes => familyGroupStore.patchAsync(props.familyGroupId!, changes))

</script>
